import { Entity } from '@/store/shared/entity'
export default class LogisticsCostEntity extends Entity<number>{
    declareCustomsId:number;
    logisticsId:number;    
    logisticsName:string;
    logisticsNameAndAmount:string;
    amount:number;
    currency:string='RMB';
    invoiceNumber:string;
    paymentDate:Date;
    remark:string;
    exchangeRate:number;
}